import { UserPriv } from "luxedo-data"

export const LUX_AI_PRIV = "lux_ai" as UserPriv
